import AddDocumentButton from './components/AddDocumentButton/AddDocumentButton.vue'
import SearchCardDocument from './components/SearchCardDocument/SearchCardDocument.vue'
import TableDocuments from './components/TableDocuments/TableDocuments.vue'
import PermissionMixin from '@/store/module/permission/mixin'
import Roles from '@/shared/utils/roles.js'

export default{
  components: {
    AddDocumentButton,
    SearchCardDocument,
    TableDocuments
  },
  mixins: [ PermissionMixin ],
  data () {
    return {
      keyTableDocuments: 0,
      roles: Roles
    }
  },
  methods: {
    GetFilter (filter, isFilter) {
      this.$refs.tableDocuments.searchWithFilter(filter, isFilter)
    },
    updateTableDocuments () {
      this.keyTableDocuments++
    }
  },
  name: 'DocumentsManagement'
}



// WEBPACK FOOTER //
// ./src/views/private/documentsManagement/documentsManagement.js